import { render, staticRenderFns } from "./ViewFnAssess.vue?vue&type=template&id=06fecca8&scoped=true&"
import script from "./ViewFnAssess.vue?vue&type=script&lang=js&"
export * from "./ViewFnAssess.vue?vue&type=script&lang=js&"
import style0 from "./ViewFnAssess.vue?vue&type=style&index=0&id=06fecca8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fecca8",
  null
  
)

export default component.exports